export default class BaseUser{
	constructor({userId = '', mobile = '', psd = ''}) {
	    this.userId = userId
		this.mobile = mobile
		this.psd = psd
	}
}